import React from 'react';
import { useSelector } from 'react-redux';
import {
  orgNameSelector,
  orgPlanNameSelector,
  orgPhoneNumbersSelector,
  orgPayPeriodSelector,
  orgPlanSelector,
} from '../../../redux/app/selectors/organization';

interface SubscriptionDetailsPlanSection {
  handleClick: (any) => void;
}

export const SubscriptionDetailsPlanSection = ({ handleClick }: SubscriptionDetailsPlanSection) => {
  const plan = useSelector(orgPlanSelector);
  const planName = useSelector(orgPlanNameSelector);
  const payPeriod = useSelector(orgPayPeriodSelector);
  const name = useSelector(orgNameSelector);
  const phoneNumbers = useSelector(orgPhoneNumbersSelector);
  const isTrialPlan = plan === 'trial-plan-4';
  const pp = payPeriod === 'monthly' ? '(Monthly)' : '(Annual)';

  return (
    <div className="body">
      <div className="column-left">
        <p className="fsz-16 bold-900">Plan</p>
      </div>
      <div className="column-mid">
        <p className="fsz-16 mb-5 bold-800">
          {planName}
          &nbsp;
          {isTrialPlan ? '' : pp}
        </p>
        <p className="fsz-13 mb-5">
          Organization:&nbsp;
          {name}
        </p>
        <p className="fsz-13">
          Avochato Numbers:&nbsp;
          {phoneNumbers.join(',')}
        </p>
      </div>
      <div className="column-right flex justify-end width-100">
        <button
          type="button"
          className="button burnt-orange height-fit-content transition-none"
          data-checkouttype="addPlanUpgrade"
          onClick={handleClick}
        >
          Upgrade
        </button>
      </div>
    </div>
  );
};
